import styled from "styled-components";
import { colorTokens } from "../../../tokens";

export const StyledCanvas = styled.canvas`
  width: 100%;
  height: 100vh;
  background-color: ${colorTokens.backgroundDark};
`;
